import { useState } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

import { BRAND_YELLOW, ENDPOINT, SETUP_STEPS } from "../data";

export default function GetStarted() {
  return (
    <div className="max-w-2xl mx-auto py-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <Logo label="Jobego" filled />
          <span className="text-2xl font-extrabold text-gray-400">↔</span>
          <Logo label="Claude" dark />
        </div>
        <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight mb-3">Connect Jobego to Claude</h1>
        <p className="text-gray-500 leading-relaxed">
          Search jobs, review candidates, send messages — without leaving your AI.
        </p>
      </div>

      <div className="mb-12">
        <CopyField label="MCP Endpoint" value={ENDPOINT} />
        <div className="mt-3 flex items-center justify-center gap-2 text-xs text-gray-500">
          <span className="relative flex w-2 h-2">
            <span className="absolute inline-flex w-full h-full rounded-full bg-green-500 opacity-60 animate-ping" />
            <span className="relative inline-flex w-2 h-2 rounded-full bg-green-500" />
          </span>
          Operational
        </div>
      </div>

      <div>
        <h2 className="text-center text-xs font-extrabold uppercase tracking-widest text-gray-500 mb-6">How to setup</h2>
        <ol className="relative max-w-md mx-auto">
          <span className="absolute left-[15px] top-4 bottom-4 w-px bg-gray-200" />
          {SETUP_STEPS.map((step, i) => (
            <li key={i} className="relative flex gap-4 pb-5 last:pb-0">
              <span
                className="relative z-10 flex-shrink-0 w-8 h-8 rounded-full text-black text-sm font-extrabold flex items-center justify-center border-2 border-black"
                style={{ backgroundColor: BRAND_YELLOW }}>
                {i + 1}
              </span>
              <span className="text-sm text-gray-700 leading-relaxed pt-1.5">{step}</span>
            </li>
          ))}
        </ol>
      </div>

      <p className="mt-16 pt-6 border-t border-gray-200 text-xs text-gray-400 text-center">
        Every call is scoped to your account and requires an organisation you belong to. Authentication via OAuth 2.1.
      </p>
    </div>
  );
}

function Logo({ label, filled, dark }) {
  return (
    <div
      className={`w-16 h-16 rounded-2xl border-2 border-black shadow-[4px_4px_0_0_rgba(0,0,0,1)] flex items-center justify-center font-extrabold text-sm ${
        dark ? "bg-black text-white" : "text-black"
      }`}
      style={filled ? { backgroundColor: BRAND_YELLOW } : undefined}>
      {dark ? "C" : label[0]}
    </div>
  );
}

function CopyField({ label, value }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div>
      <label className="block text-center text-xs font-extrabold uppercase tracking-widest text-gray-500 mb-3">
        {label}
      </label>
      <div className="flex items-center gap-2 border-2 border-black rounded-xl px-4 py-3.5 bg-white shadow-[4px_4px_0_0_rgba(0,0,0,1)]">
        <code className="flex-1 text-sm font-mono text-black truncate">{value}</code>
        <button
          onClick={handleCopy}
          className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-lg hover:bg-black/5 text-black transition-colors cursor-pointer"
          aria-label="Copy">
          {copied ? <FiCheck className="w-5 h-5" style={{ color: BRAND_YELLOW }} /> : <FiCopy className="w-5 h-5" />}
        </button>
      </div>
    </div>
  );
}
